import { RemoveCookieOptions, remove, set } from '../cookies';

import { WriteCookie, WriteHostingCookieOptions, writeHostingCookie } from './writeHostingCookie';

const ThirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000;

const RingInfoCookieName = 'ring_info';
const RingInfoMetatagName = 'ringInfo';

const writeCookie: WriteCookie = (value, cookieOptions) => {
  set(RingInfoCookieName, value, cookieOptions);
};

const getRingInfo = () => {
  const { head } = document;
  const metaTag: HTMLMetaElement | null = head.querySelector(`[name='${RingInfoMetatagName}']`);

  return metaTag?.content ?? '';
};

type WriteRingInfoCookie = (shouldSetSameSite: boolean, path: string) => void;
export const writeRingInfoCookie: WriteRingInfoCookie = (shouldSetSameSite, path) => {
  const ringInfo = getRingInfo();

  const options: WriteHostingCookieOptions = {
    cookieName: RingInfoCookieName,
    cookieValue: ringInfo,
    shouldWriteCookie: () => !!ringInfo,
    writeCookie,
    shouldSetSameSite,
    expires: new Date(Date.now() + ThirtyDaysInMilliseconds),
    path,
  };

  writeHostingCookie(options);
};

type ClearRingInfoCookie = (path: string) => void;
export const clearRingInfoCookie: ClearRingInfoCookie = (path) => {
  const options: RemoveCookieOptions | undefined = { path };

  remove(RingInfoCookieName, options);
};
